import axios from 'axios'
import { apiLocale } from '../i18n'
const client=axios.create({baseURL:'',timeout:15000})
client.interceptors.request.use(config=>{const token=localStorage.getItem('ES_TOKEN');config.params={lang:apiLocale(localStorage.getItem('RS_LANG')||'en'),...(config.params||{})};if(token&&!config.skipAuth)config.params.token=token;return config})
client.interceptors.response.use(r=>{if(r.data&&String(r.data.code)!=='0')return Promise.reject(new Error(r.data.msg||'Request failed'));return r.data})
export const post=(url,params={},options={})=>client.post(url,null,{...options,params})
export const get=(url,params={},options={})=>client.get(url,{...options,params})
